import {columns} from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/workType'
export const namespace = 'workType'
export const clientRoute = '/company/work-type'
export const dependencies = []
export const params = {
  include: ''
  // sort: ''
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'description'
const subtitleColumn = undefined
const infoColumns = []
/* --------------------------- */

const state = {
  defaultSort: 'description',
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
